import * as React from 'react';
import { ViewContainer } from '../ViewContainer';
import { AgreementContainer } from './containers/AgreementContainer';
import { AgreementContainerV2 } from './containers/AgreementContainerV2';
import { HelpContainer } from '../HelpContainer';
import { RootContext } from '../RootContainer';
import { trackAgreementOpen } from './tracking';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export var AgreementView = function AgreementView(_ref) {
  var source = _ref.source;
  var _React$useContext = React.useContext(RootContext),
    isRedesignExperimentEnabled = _React$useContext.isRedesignExperimentEnabled;
  React.useEffect(function () {
    if (!isRedesignExperimentEnabled) {
      trackAgreementOpen(source);
    }
  }, []);
  return /*#__PURE__*/_jsx(ViewContainer, {
    children: isRedesignExperimentEnabled ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(AgreementContainerV2, {}), /*#__PURE__*/_jsx(HelpContainer, {})]
    }) : /*#__PURE__*/_jsx(AgreementContainer, {})
  });
};